import React, { useState } from "react";
import { api } from "../api";

export default function Superadmin() {
    const [userId, setUserId] = useState("");
    const [role, setRole] = useState("1");
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState("");
    const [msg, setMsg] = useState("");

    async function onSubmit(e) {
        e.preventDefault();
        setErr("");
        setMsg("");
        setBusy(true);
        try {
            await api.usersSetRole(Number(userId), Number(role));
            setMsg("Role nastavena.");
            setUserId("");
        } catch (e2) {
            setErr(e2 && e2.message ? e2.message : "setrole_failed");
        } finally {
            setBusy(false);
        }
    }

    return (
        <section className="card overflow-hidden">
            <div className="cardHeader">
                <div className="text-text-100 font-extrabold text-2xl">Superadmin</div>
                <div className="text-text-300 mt-2">Nastavení rolí</div>
            </div>

            <div className="cardBody">
                <form onSubmit={onSubmit} className="space-y-6">
                    <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
                        <div>
                            <div className="label">User ID</div>
                            <input value={userId} onChange={(e) => setUserId(e.target.value)} className="input mt-3" inputMode="numeric" autoComplete="off" />
                        </div>

                        <div>
                            <div className="label">Role</div>
                            <select value={role} onChange={(e) => setRole(e.target.value)} className="input mt-3">
                                <option value="0">User</option>
                                <option value="1">Admin</option>
                                <option value="2">Superadmin</option>
                            </select>
                        </div>
                    </div>

                    {err ? (
                        <div className="rounded-2xl border border-bad/35 bg-bad/10 p-4">
                            <div className="text-text-100 font-semibold">Nelze nastavit</div>
                            <div className="text-text-200 text-sm mt-1">{err}</div>
                        </div>
                    ) : null}

                    {msg ? (
                        <div className="rounded-2xl border border-ok/35 bg-ok/10 p-4">
                            <div className="text-text-100 font-semibold">{msg}</div>
                        </div>
                    ) : null}

                    <button disabled={busy} className={busy ? "btnPrimary opacity-60 cursor-not-allowed" : "btnPrimary"}>
                        {busy ? "Ukládám" : "Nastavit roli"}
                    </button>
                </form>
            </div>
        </section>
    );
}
